export const coreValuesSections = [
  {
    title: "Transparent, direct & upfront",
    bulletPoints: [
      {
        text: "At Verse, we really value being able to speak our minds. We try hard to tell like it is. This means that we're clear when things are going well and when things are going poorly, whether this is at the company level, team level or individual level.",
      },
      {
        text: "Sometimes, we're not the best at sugarcoating or being diplomatic internally. This doesn't give anyone a license to ever be rude or mean in the workplace, but we do tend to be pretty direct with our thoughts.",
      },
    ],
  },
  {
    title: "Speed of iteration",
    bulletPoints: [
      {
        text: "At Verse, we're fundamentally creating a new product category. There isn't an existing product that solves the problem that we're tackling. As a consequence, we're solving problems that other people haven't already solved pretty much every day. Often times, our initial approach to solving problems isn't going to be the right one. We believe that we'll get to the right approach through iteration and not through overly careful strategizing.",
      },
      {
        text: "Of course, we want to have enough pre-planning for every project to meet the demands of a heavily regulated & mission critical industry like healthcare. But, with this constraint in mind, we always want to have an eye toward getting things in the hands of users as quickly as we can.",
      },
    ],
  },
  {
    title: "110% effort, 30% of the time",
    bulletPoints: [
      {
        text: "We're a startup and at times, raw effort and hours make a difference. But, we also want to work in an environment that's invigorating & exciting, not one that's draining.",
      },
      {
        text: "Most of the time, people on our team work pretty regular hours like they might at any other job. But, when company needs call for it, team members are expected to go the extra mile.",
      },
      {
        text: "To be clear, we're not a 110% effort 100% of the time sort of company. That'd be a miserable place to work. But, as a fairly small company, we face existential risk every day. We can't afford to operate at 80% effort.",
      },
    ],
  },
  {
    title: "Empathize with customers to a fault",
    bulletPoints: [
      {
        text: "Every company says they are customer obsessed. It's become table stakes to really care about what your customers think about you or risk going out of business.",
      },
      {
        text: "At Verse however, we have a very specific interpretation of this value. Any time a customer has a problem, we ask ourselves: “how can Verse make this better?” and we don't immediately ask: “how could the nurse/patient change their behavior?”",
      },
      {
        text: "In healthcare, it's easy to get frustrated, whether you're interacting with clinicians, patients or insurance plans. The whole system is a complete and total mess. But, when we find ourselves in unfortunate situations, our first thought should be “how do we solve this problem for this patient/nurse?” Some of our best ideas have come from this line of questioning and it's become a critical part of how we operate.",
      },
      {
        text: "This means that if you bring up an issue with a given customer at Verse, whether it involves a clinician or patient, you should expect that the first question the team will ask is how we can change what we are doing, not change how the customer operates.",
      },
    ],
  },
];

export const challengeItems = [
  {
    src: "/landing_page_assets/icons/Fax.svg",
    title: "95+%",
    subtitle: "of DME is ordered over fax",
    className: "tw-h-[3.5em] tw-w-[3.5em]",
  },
  {
    src: "/landing_page_assets/icons/Reuse.svg",
    title: "75+%",
    subtitle: "of orders require communication after the order is placed",
    className: "tw-h-[3.5em] tw-w-[3.5em]",
  },
  {
    src: "/landing_page_assets/icons/Clock.svg",
    title: "50+%",
    subtitle: "of orders are delayed",
    className: "tw-h-[3.5em] tw-w-[3.5em]",
  },
  {
    src: "/landing_page_assets/icons/Money.svg",
    title: "39%",
    subtitle: "of DME spend ($50B+ a year) is wasted",
    className: "tw-h-[3.5em] tw-w-[3.5em]",
  },
];
